import { render, staticRenderFns } from "./RDTStatus.vue?vue&type=template&id=85c2dc1c"
import script from "./RDTStatus.vue?vue&type=script&lang=js"
export * from "./RDTStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports